export const contentWrapper = 'h-full overflow-y-auto bg-white';
export const button = 'w-full mt-4';
export const buttonIcon = 'w-5 h-5 ml-2';
export const buttonIconStyle = 'h-5 w-5 text-primary mr-1';
export const contactButtons = 'flex mt-4';
